import { render, staticRenderFns } from "./AddUser2.vue?vue&type=template&id=40c3991b&"
import script from "./AddUser2.vue?vue&type=script&lang=js&"
export * from "./AddUser2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports